const translations = {
  ar: {
    nav: {
      searchPlaceholder: "ابحث عن المنتجات...",
      seeAllResults: "عرض كل النتائج",
      noResults: "لا توجد نتائج مطابقة",
      categories: "الأقسام",
      phone: "+216 27 628 111",
    },
    movingMsg: "توصيل سريع إلى جميع أنحاء الجمهورية التونسية ",
    hero: {
      badge: "منتجات طبيعية 100% مضمونة",
      title: "موقع ",
      subtitle: "بن موسى للأعشاب الطبية",
      description: "متخصص في بيع الأدوية والأعشاب الطبية، المكملات الطبيعية، والزيوت الروحية",
      primaryBtn: "جميع المنتجات",
      secondaryBtn: "اكتشف أقسامنا",
      trustGuaranteed: "مضمون 100%",
      trustDelivery: "توصيل لكامل الجمهورية",
    },
    categories: {
      title: "تصفح حسب الفئة",
      viewAll: "عرض الكل",
      sub: "أقسام",
      browseNow: "تصفح الآن",
    },
    home: {
      bestSellers: "الأكثر مبيعاً",
      newArrivals: "منتجات جديدة",
      bestSellersMsg: "الأكثر طلباً",
      newMsg: "جديد",
      packTitle: "خلطات",
      packMsg: "خلطة",
      featuredTitle: "منتجات مميزة",
      featuredMsg: "مميز",
      promoTitle: "عروض وتخفيضات",
    },
    product: {
      addToCart: "أضف للسلة",
      added: "تمت الإضافة",
      chooseSize: "اختر الحجم المناسب:",
      unavailable: "غير متوفر",
      lowStock: "كمية محدودة",
      outOfStock: "نفذ المخزون",
      notAvailable: "هذا المنتج غير متوفر حالياً",
      notFound: "المنتج غير موجود",
      availableSizes: "الأحجام المتوفرة",
      buyNow: "اشتري الآن",
      quantity: "الكمية",
      addToCartBtn: "إضافة إلى السلة",
      deliveryMsg: "توصيل سريع لكامل الجمهورية",
      guaranteed: "منتج مضمون",
      relatedProducts: "منتجات من نفس الفئة",
      perUnit: "للوحدة",
      category: "قسم",
      descriptionTab: "وصف المنتج",
      reviewsTab: "التعليقات",
      noDescription: "لا يوجد وصف مفصل متاح لهذا المنتج حالياً.",
    },
    comments: {
      rateProduct: "قيّم المنتج",
      yourName: "اسمك",
      namePlaceholder: "أدخل اسمك",
      yourComment: "تعليقك",
      commentPlaceholder: "شاركنا رأيك في هذا المنتج...",
      submit: "إرسال التعليق",
      noComments: "لا توجد تعليقات بعد، كن أول من يعلّق!",
      submitted: "تم إرسال تعليقك بنجاح!",
      pendingApproval: "سيظهر تعليقك بعد مراجعته من قِبَل الإدارة.",
      submitError: "حدث خطأ أثناء الإرسال، يرجى المحاولة مرة أخرى.",
      writeReview: "اكتب تعليقاً",
    },
    productsPage: {
      store: "المتجر",
      allProducts: "كافة المنتجات",
      searchResults: "نتائج البحث عن",
      sectionsTitle: "الأقسام الفرعية",
      browseSection: "تصفح القسم",
      all: "الكل",
      sort: "ترتيب:",
      sortAZ: "الاسم: أ-ي",
      sortZA: "الاسم: ي-أ",
      sortPriceLow: "السعر: الأدنى",
      sortPriceHigh: "السعر: الأعلى",
      sortOptions: ["الاسم: أ-ي", "الاسم: ي-أ", "السعر: الأدنى", "السعر: الأعلى"],
      available: "منتج متوفر",
      noProducts: "لم يتم العثور على منتجات حالياً.",
      allLoaded: "— تم تحميل جميع المنتجات —",
      inCategory: "منتج في هذا القسم",
      noCategoryProducts: "لا توجد منتجات متوفرة حالياً في هذا القسم.",
      backToParent: "العودة للقسم الرئيسي",
      bestSellers: "الأكثر مبيعاً",
      mostRequested: "الأكثر طلباً",
      browseProducts: "تصفح المنتجات",
      filterAll: "الكل",
      filterMostSold: "الأكثر مبيعاً",
      filterNew: "جديد",
      filterFeatured: "مميز",
      filterPack: "خلطات",
      filterPromo: "عروض",
      filterAvailable: "متوفر",
      filterLowStock: "كمية محدودة",
      filterOutOfStock: "نفذ المخزون",
      filterType: "نوع المنتج",
      filterAvailability: "التوفر",
      clearFilters: "مسح الفلاتر",
    },
    articles: {
      title: "مقالات مختارة",
      subtitle: "اكتشف أحدث المقالات والنصائح الصحية",
      readMore: "اقرأ المزيد",
      viewAll: "جميع المقالات",
    },
    videos: {
      title: "فيديوهات تعليمية",
      subtitle: "تعرف على منتجاتنا وطريقة استخدامها",
      howToUse: "طريقة استخدام المنتج",
      viewAll: "جميع الفيديوهات",
    },
    cart: {
      title: "سلة الشراء",
      itemsCount: "لديك {count} منتج في السلة",
      emptyCart: "سلتك فارغة",
      products: "المنتجات",
      shipping: "التوصيل",
      total: "المجموع النهائي",
      free: "مجاني",
      checkout: "إتمام الطلب",
      emptyTitle: "سلة التسوق فارغة",
      emptyMsg: "ابدأ بإضافة منتجاتك الطبيعية المفضلة",
      browseStore: "تصفح المتجر",
      continueShopping: "مواصلة التسوق",
      orderSummary: "ملخص الطلب",
      freeShippingHint: "أضف منتجات بقيمة {amount} د.ت للحصول على توصيل مجاني",
    },
    checkout: {
      title: "إتمام الطلب",
      deliveryInfo: "معلومات التوصيل",
      firstName: "الاسم",
      lastName: "اللقب",
      phone: "رقم الهاتف",
      governorate: "الولاية",
      address: "العنوان بالكامل",
      addressPlaceholder: "الشارع، رقم المنزل، الطابق...",
      orderSummary: "ملخص الطلبية",
      subtotal: "المجموع الفرعي",
      shippingCost: "مصاريف الشحن",
      total: "الإجمالي",
      confirmOrder: "تأكيد الطلب",
      confirmOrderNow: "تأكيد الطلبية الآن",
      free: "مجاني",
      cashOnDelivery: "Cash on Delivery",
      successTitle: "شكراً لثقتكم!",
      successMsg: "تم استلام طلبك بنجاح. فريق BenMoussaHerbs سيقوم بالاتصال بك قريباً لتأكيد تفاصيل التوصيل.",
      backToStore: "العودة للمتجر",
      orderError: "حدث خطأ أثناء إرسال الطلب.",
      invalidPhone: "رقم الهاتف غير صحيح",
      validPhone: "رقم الهاتف صحيح",
      phoneRequired: "أدخل رقم هاتف صحيح للمتابعة",
      optionalInfo: "معلومات إضافية (اختياري)",
    },
    sideProducts: {
      viewAll: "عرض كافة المنتجات",
    },
    breadcrumb: {
      home: "الرئيسية",
      store: "المتجر",
      categories: "الأقسام",
      products: "المنتجات",
    },
    footer: {
      tagline: "نحن نهتم بصحتكم من خلال تقديم أفضل ما تجود به الطبيعة التونسية.",
      aboutTitle: "من نحن",
      aboutText: "بن موسى هي علامة تجارية تونسية رائدة متخصصة في توفير أجود أنواع الزيوت الطبيعية والمكملات الغذائية المختارة بعناية فائقة.",
      categoriesTitle: "التصنيفات",
      oils: "الزيوت الطبيعية",
      honey: "منتجات العسل",
      supplements: "المكملات الطبيعية",
      helpTitle: "المساعدة",
      faq: "الأسئلة الشائعة",
      shippingPolicy: "سياسة الشحن",
      contactUs: "اتصل بنا",
      contactTitle: "معلومات التواصل",
      address: "رادس، بن عروس، تونس",
      email: "contact@benmoussa.tn",
      safeShopping: "تسوق آمن 100%",
      allRights: "جميع الحقوق محفوظة.",
      privacy: "سياسة الخصوصية",
      terms: "شروط الاستخدام",
      newsletterTitle: "ابق على اطلاع",
      newsletterDesc: "اشترك لتصلك أحدث العروض والمنتجات الجديدة.",
      newsletterPlaceholder: "بريدك الإلكتروني",
      newsletterBtn: "اشترك",
    },
    notFound: {
      title: "الصفحة غير موجودة",
      msg: "عذراً، الصفحة التي تبحث عنها غير متوفرة.",
      back: "العودة للرئيسية",
    },
  },

  fr: {
    nav: {
      searchPlaceholder: "Rechercher des produits...",
      seeAllResults: "Voir tous les résultats",
      noResults: "Aucun résultat trouvé",
      categories: "Catégories",
      phone: "+216 27 628 111",
    },
    movingMsg: "Livraison rapide dans toute la République Tunisienne ",
    hero: {
      badge: "Produits 100% naturels et garantis",
      title: "BenMoussa",
      subtitle: "BenMoussa Herbes Naturelles",
      description: "Spécialisé dans la vente d'herbes médicinales, compléments naturels et huiles essentielles",
      primaryBtn: "Tous les produits",
      secondaryBtn: "Découvrir nos catégories",
      trustGuaranteed: "Garanti 100%",
      trustDelivery: "Livraison nationale",
    },
    categories: {
      title: "Parcourir par catégorie",
      viewAll: "Voir tout",
      sub: "sections",
      browseNow: "Parcourir",
    },
    home: {
      bestSellers: "Meilleures ventes",
      newArrivals: "Nouveautés",
      bestSellersMsg: "Populaire",
      newMsg: "Nouveau",
      packTitle: "Mélanges",
      packMsg: "Mélange",
      featuredTitle: "Produits Vedettes",
      featuredMsg: "Vedette",
      promoTitle: "Offres & Promotions",
    },
    product: {
      addToCart: "Ajouter au panier",
      added: "Ajouté",
      chooseSize: "Choisir la taille:",
      unavailable: "Indisponible",
      lowStock: "Stock limité",
      outOfStock: "Rupture de stock",
      notAvailable: "Ce produit est actuellement indisponible",
      notFound: "Produit introuvable",
      availableSizes: "Tailles disponibles",
      buyNow: "Acheter maintenant",
      quantity: "Quantité",
      addToCartBtn: "Ajouter au panier",
      deliveryMsg: "Livraison rapide nationale",
      guaranteed: "Produit garanti",
      relatedProducts: "Produits de la même catégorie",
      perUnit: "/ unité",
      category: "Catégorie",
      descriptionTab: "Description",
      reviewsTab: "Avis",
      noDescription: "Aucune description détaillée disponible pour ce produit.",
    },
    comments: {
      rateProduct: "Évaluer le produit",
      yourName: "Votre nom",
      namePlaceholder: "Entrez votre nom",
      yourComment: "Votre commentaire",
      commentPlaceholder: "Partagez votre avis sur ce produit...",
      submit: "Envoyer",
      noComments: "Aucun commentaire pour l'instant, soyez le premier !",
      submitted: "Commentaire envoyé avec succès !",
      pendingApproval: "Votre commentaire sera visible après validation par l'administration.",
      submitError: "Une erreur s'est produite, veuillez réessayer.",
      writeReview: "Écrire un avis",
    },
    productsPage: {
      store: "Boutique",
      allProducts: "Tous les produits",
      searchResults: "Résultats pour",
      sectionsTitle: "Sous-catégories",
      browseSection: "Parcourir la section",
      all: "Tous",
      sort: "Trier:",
      sortAZ: "Nom: A-Z",
      sortZA: "Nom: Z-A",
      sortPriceLow: "Prix: croissant",
      sortPriceHigh: "Prix: décroissant",
      sortOptions: ["Nom: A-Z", "Nom: Z-A", "Prix: croissant", "Prix: décroissant"],
      available: "produit(s) disponible(s)",
      noProducts: "Aucun produit trouvé.",
      allLoaded: "— Tous les produits sont chargés —",
      inCategory: "produit(s) dans cette catégorie",
      noCategoryProducts: "Aucun produit disponible dans cette catégorie.",
      backToParent: "Retour à la catégorie principale",
      bestSellers: "Meilleures ventes",
      mostRequested: "Les plus demandés",
      browseProducts: "Parcourir les produits",
      filterAll: "Tous",
      filterMostSold: "Meilleures ventes",
      filterNew: "Nouveautés",
      filterFeatured: "En vedette",
      filterPack: "Mélanges",
      filterPromo: "Promotions",
      filterAvailable: "Disponible",
      filterLowStock: "Stock limité",
      filterOutOfStock: "Rupture de stock",
      filterType: "Type de produit",
      filterAvailability: "Disponibilité",
      clearFilters: "Effacer les filtres",
    },
    articles: {
      title: "Articles sélectionnés",
      subtitle: "Découvrez nos derniers articles et conseils santé",
      readMore: "Lire plus",
      viewAll: "Tous les articles",
    },
    videos: {
      title: "Vidéos éducatives",
      subtitle: "Découvrez nos produits et comment les utiliser",
      howToUse: "Comment utiliser le produit",
      viewAll: "Toutes les vidéos",
    },
    cart: {
      title: "Panier",
      itemsCount: "Vous avez {count} article(s) dans le panier",
      emptyCart: "Votre panier est vide",
      products: "Produits",
      shipping: "Livraison",
      total: "Total",
      free: "Gratuit",
      checkout: "Commander",
      emptyTitle: "Le panier est vide",
      emptyMsg: "Commencez à ajouter vos produits naturels préférés",
      browseStore: "Parcourir la boutique",
      continueShopping: "Continuer mes achats",
      orderSummary: "Résumé de la commande",
      freeShippingHint: "Ajoutez {amount} DT pour la livraison gratuite",
    },
    checkout: {
      title: "Finaliser la commande",
      deliveryInfo: "Informations de livraison",
      firstName: "Prénom",
      lastName: "Nom",
      phone: "Numéro de téléphone",
      governorate: "Gouvernorat",
      address: "Adresse complète",
      addressPlaceholder: "Rue, numéro, étage...",
      orderSummary: "Résumé de la commande",
      subtotal: "Sous-total",
      shippingCost: "Frais de livraison",
      total: "Total",
      confirmOrder: "Confirmer la commande",
      confirmOrderNow: "Confirmer maintenant",
      free: "Gratuit",
      cashOnDelivery: "Paiement à la livraison",
      successTitle: "Merci de votre confiance !",
      successMsg: "Votre commande a été reçue avec succès. L'équipe BenMoussaHerbs vous contactera bientôt pour confirmer les détails de livraison.",
      backToStore: "Retour à la boutique",
      orderError: "Une erreur s'est produite lors de l'envoi de la commande.",
      invalidPhone: "Numéro de téléphone invalide",
      validPhone: "Numéro valide",
      phoneRequired: "Entrez un numéro valide pour continuer",
      optionalInfo: "Informations supplémentaires (optionnel)",
    },
    sideProducts: {
      viewAll: "Voir tous les produits",
    },
    breadcrumb: {
      home: "Accueil",
      store: "Boutique",
      categories: "Catégories",
      products: "Produits",
    },
    footer: {
      tagline: "Nous prenons soin de votre santé en offrant le meilleur de la nature tunisienne.",
      aboutTitle: "À propos",
      aboutText: "BenMoussa est une marque tunisienne leader spécialisée dans la fourniture des meilleures huiles naturelles et compléments alimentaires soigneusement sélectionnés.",
      categoriesTitle: "Catégories",
      oils: "Huiles naturelles",
      honey: "Produits du miel",
      supplements: "Compléments naturels",
      helpTitle: "Aide",
      faq: "FAQ",
      shippingPolicy: "Politique de livraison",
      contactUs: "Nous contacter",
      contactTitle: "Contact",
      address: "Rades, Ben Arous, Tunisie",
      email: "contact@benmoussa.tn",
      safeShopping: "Achats 100% sécurisés",
      allRights: "Tous droits réservés.",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
      newsletterTitle: "Restez informé",
      newsletterDesc: "Abonnez-vous pour recevoir nos dernières offres et nouveaux produits.",
      newsletterPlaceholder: "Votre email",
      newsletterBtn: "S'abonner",
    },
    notFound: {
      title: "Page introuvable",
      msg: "Désolé, la page que vous recherchez n'existe pas.",
      back: "Retour à l'accueil",
    },
  },

  en: {
    nav: {
      searchPlaceholder: "Search for products...",
      seeAllResults: "See all results",
      noResults: "No matching results found",
      categories: "Categories",
      phone: "+216 27 628 111",
    },
    movingMsg: "Fast delivery across all of Tunisia ",
    hero: {
      badge: "100% Natural & Guaranteed Products",
      title: "BenMoussa",
      subtitle: "BenMoussa Natural Herbs",
      description: "Specialized in natural herbs, medicinal plants, natural supplements and essential oils",
      primaryBtn: "All Products",
      secondaryBtn: "Discover Our Categories",
      trustGuaranteed: "100% Guaranteed",
      trustDelivery: "Nationwide Delivery",
    },
    categories: {
      title: "Browse by Category",
      viewAll: "View All",
      sub: "sections",
      browseNow: "Browse Now",
    },
    home: {
      bestSellers: "Best Sellers",
      newArrivals: "New Arrivals",
      bestSellersMsg: "Popular",
      newMsg: "New",
      packTitle: "Blends",
      packMsg: "Blend",
      featuredTitle: "Featured Products",
      featuredMsg: "Featured",
      promoTitle: "Deals & Promotions",
    },
    product: {
      addToCart: "Add to Cart",
      added: "Added",
      chooseSize: "Choose Size:",
      unavailable: "Unavailable",
      lowStock: "Low Stock",
      outOfStock: "Out of Stock",
      notAvailable: "This product is currently unavailable",
      notFound: "Product not found",
      availableSizes: "Available Sizes",
      buyNow: "Buy Now",
      quantity: "Quantity",
      addToCartBtn: "Add to Cart",
      deliveryMsg: "Fast nationwide delivery",
      guaranteed: "Guaranteed product",
      relatedProducts: "Products from the same category",
      perUnit: "/ unit",
      category: "Category",
      descriptionTab: "Description",
      reviewsTab: "Reviews",
      noDescription: "No detailed description available for this product.",
    },
    comments: {
      rateProduct: "Rate this product",
      yourName: "Your name",
      namePlaceholder: "Enter your name",
      yourComment: "Your comment",
      commentPlaceholder: "Share your thoughts on this product...",
      submit: "Submit",
      noComments: "No reviews yet, be the first to comment!",
      submitted: "Your comment was submitted successfully!",
      pendingApproval: "Your review will appear once approved by the admin.",
      submitError: "Something went wrong, please try again.",
      writeReview: "Write a Review",
    },
    productsPage: {
      store: "Store",
      allProducts: "All Products",
      searchResults: "Results for",
      sectionsTitle: "Sub-categories",
      browseSection: "Browse Section",
      all: "All",
      sort: "Sort:",
      sortAZ: "Name: A-Z",
      sortZA: "Name: Z-A",
      sortPriceLow: "Price: Low to High",
      sortPriceHigh: "Price: High to Low",
      sortOptions: ["Name: A-Z", "Name: Z-A", "Price: Low to High", "Price: High to Low"],
      available: "product(s) available",
      noProducts: "No products found.",
      allLoaded: "— All products loaded —",
      inCategory: "product(s) in this category",
      noCategoryProducts: "No products available in this category.",
      backToParent: "Back to Main Category",
      bestSellers: "Best Sellers",
      mostRequested: "Most Requested",
      browseProducts: "Browse Products",
      filterAll: "All",
      filterMostSold: "Best Sellers",
      filterNew: "New",
      filterFeatured: "Featured",
      filterPack: "Blends",
      filterPromo: "Deals",
      filterAvailable: "Available",
      filterLowStock: "Low Stock",
      filterOutOfStock: "Out of Stock",
      filterType: "Product Type",
      filterAvailability: "Availability",
      clearFilters: "Clear filters",
    },
    articles: {
      title: "Selected Articles",
      subtitle: "Discover our latest articles and health tips",
      readMore: "Read More",
      viewAll: "All Articles",
    },
    videos: {
      title: "Educational Videos",
      subtitle: "Learn about our products and how to use them",
      howToUse: "How to use the product",
      viewAll: "All Videos",
    },
    cart: {
      title: "Shopping Cart",
      itemsCount: "You have {count} item(s) in your cart",
      emptyCart: "Your cart is empty",
      products: "Products",
      shipping: "Shipping",
      total: "Total",
      free: "Free",
      checkout: "Checkout",
      emptyTitle: "Shopping cart is empty",
      emptyMsg: "Start adding your favorite natural products",
      browseStore: "Browse Store",
      continueShopping: "Continue Shopping",
      orderSummary: "Order Summary",
      freeShippingHint: "Add {amount} DT worth of products for free shipping",
    },
    checkout: {
      title: "Complete Order",
      deliveryInfo: "Delivery Information",
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone Number",
      governorate: "Governorate",
      address: "Full Address",
      addressPlaceholder: "Street, house number, floor...",
      orderSummary: "Order Summary",
      subtotal: "Subtotal",
      shippingCost: "Shipping Cost",
      total: "Total",
      confirmOrder: "Confirm Order",
      confirmOrderNow: "Confirm Order Now",
      free: "Free",
      cashOnDelivery: "Cash on Delivery",
      successTitle: "Thank you for your trust!",
      successMsg: "Your order has been received successfully. The BenMoussaHerbs team will contact you soon to confirm delivery details.",
      backToStore: "Back to Store",
      orderError: "An error occurred while submitting your order.",
      invalidPhone: "Invalid phone number",
      validPhone: "Valid phone number",
      phoneRequired: "Enter a valid phone number to continue",
      optionalInfo: "Additional information (optional)",
    },
    sideProducts: {
      viewAll: "View All Products",
    },
    breadcrumb: {
      home: "Home",
      store: "Store",
      categories: "Categories",
      products: "Products",
    },
    footer: {
      tagline: "We care for your health by offering the best of Tunisian nature.",
      aboutTitle: "About Us",
      aboutText: "BenMoussa is a leading Tunisian brand specializing in providing the finest natural oils and carefully selected nutritional supplements.",
      categoriesTitle: "Categories",
      oils: "Natural Oils",
      honey: "Honey Products",
      supplements: "Natural Supplements",
      helpTitle: "Help",
      faq: "FAQ",
      shippingPolicy: "Shipping Policy",
      contactUs: "Contact Us",
      contactTitle: "Contact Info",
      address: "Rades, Ben Arous, Tunisia",
      email: "contact@benmoussa.tn",
      safeShopping: "100% Safe Shopping",
      allRights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      newsletterTitle: "Stay Updated",
      newsletterDesc: "Subscribe to receive our latest offers and new products.",
      newsletterPlaceholder: "Your email address",
      newsletterBtn: "Subscribe",
    },
    notFound: {
      title: "Page Not Found",
      msg: "Sorry, the page you're looking for doesn't exist.",
      back: "Back to Home",
    },
  },
};

export default translations;
